export default __webpack_public_path__ + "static/media/tail-eth.a0a1aa7b.svg";